import { PatientSubscriptionStatusType } from 'services/patientSubscription/types';

interface PatientSubscriptionStatusSchema {
  tooltipText: string;
  statusColor: string;
  label: string;
  isMultiline: boolean;
}

export const patientSubscriptionStatusSchema: Record<
  PatientSubscriptionStatusType | 'UNSUBSCRIBED',
  PatientSubscriptionStatusSchema
> = {
  [PatientSubscriptionStatusType.TRIAL]: {
    tooltipText: 'V2CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.SUBSCRIBERDATE',
    statusColor: '#539775',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.TRIAL',
    isMultiline: false,
  },
  [PatientSubscriptionStatusType.TRIAL_CANCEL_REQUESTED]: {
    tooltipText: 'V2CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.DISCONNECTIONDATE',
    statusColor: '#CA4808',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.CANCELINGTRIAL',
    isMultiline: true,
  },
  [PatientSubscriptionStatusType.ACTIVE]: {
    tooltipText: 'V2CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.RENEWDATE',
    statusColor: '#539775',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.ACTIVE',
    isMultiline: false,
  },
  [PatientSubscriptionStatusType.RENEWAL_CANCEL_REQUESTED]: {
    tooltipText: 'V2CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.DISCONNECTIONDATE',
    statusColor: '#CA4808',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.CANCELING',
    isMultiline: true,
  },
  [PatientSubscriptionStatusType.CANCELLED]: {
    tooltipText: 'V2CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.UNSUBSCRIBEDDATE',
    statusColor: '#CA4808',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.CANCELED',
    isMultiline: false,
  },
  UNSUBSCRIBED: {
    tooltipText: 'CAREMATRIXCPTC.SUBSCRIPTIONTOOLTIP.NOSUBSCRIPTION',
    statusColor: '#6B6B78',
    label: 'CAREMATRIXCPTC.SUBSCRIPTIONSTATUS.NOSUBSCRIPTION',
    isMultiline: false,
  },
};
